import type React from 'react';

import { type PropsWithChildren } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { type NotificationDto } from '@/api/generated/models/notification-dto';
import { NotificationTypeDto } from '@/api/generated/models/notification-type-dto';
import { useGetNotifications } from '@/api/useGetNotifications.util';

import { NotificationsContext, type NotificationsContextProps } from './Notifications.context';

export const NotificationsContextProvider: React.FC<PropsWithChildren> = props => {
  const [menuBadges, setMenuBadges] = useState<Record<NotificationTypeDto, NotificationDto[]>>({
    [NotificationTypeDto.AccountsAwaitingApproval]: [],
  });
  const [isFeedbackDialogVisible, setIsFeedbackDialogVisible] = useState(false);

  const { getNotifications } = useGetNotifications();

  const updateNotifications = useCallback(async (types?: NotificationTypeDto[]) => {
    const response = await getNotifications(types);
    setMenuBadges(cur => {
      const copy = { ...cur };
      response.notifications.forEach(notification => {
        copy[notification.type].push(notification);
      });

      return copy;
    });
  }, []);

  const openFeedbackDialog = () => {
    setIsFeedbackDialogVisible(true);
  };

  const closeFeedbackDialog = () => {
    setIsFeedbackDialogVisible(false);
  };

  const context: NotificationsContextProps = useMemo(() => {
    return {
      closeFeedbackDialog,
      isFeedbackDialogVisible,
      menuBadges,
      openFeedbackDialog,
      setMenuBadges,
      updateNotifications,
    };
  }, [isFeedbackDialogVisible, menuBadges, updateNotifications]);

  return (
    <>
      <NotificationsContext value={context}>{props.children}</NotificationsContext>
    </>
  );
};
